import type { EmptyStateProps, PageHeaderProps } from "../types";
import { EditableTitle } from "@/components/editable-title";

export function PaperPageHeader({ title, icon, actions, below, media, details, accent, onRename, renameMaxLength = 120, onIconClick }: PageHeaderProps) {
  return (
    <header className="mb-5">
      <div className="relative flex min-h-9 flex-wrap items-center gap-x-4 gap-y-2">
        {accent && <span aria-hidden className="absolute inset-y-1 -left-3.5 w-[3px] rounded-full" style={{ background: accent }} />}
        {media ? (
          <h1 className="min-w-0">
            <span className="sr-only">{title}</span>
            {media}
          </h1>
        ) : (
          <h1 className="flex min-w-0 items-center gap-2.5 text-[26px] font-semibold leading-tight tracking-[-0.015em] text-foreground">
            {icon &&
              (onIconClick ? (
                <button
                  type="button"
                  aria-label="Change icon"
                  onClick={onIconClick}
                  className="-m-1 inline-flex shrink-0 rounded-md p-1 text-foreground/70 outline-none transition-colors hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring/40 [&_svg]:size-[22px]"
                >
                  {icon}
                </button>
              ) : (
                <span className="inline-flex shrink-0 text-foreground/70 [&_svg]:size-[22px]">{icon}</span>
              ))}
            {onRename ? <EditableTitle value={title} onCommit={onRename} maxLength={renameMaxLength} /> : <span className="truncate">{title}</span>}
          </h1>
        )}
        {actions && <div className="ml-auto flex min-w-0 flex-wrap items-center justify-end gap-1.5">{actions}</div>}
      </div>
      {details && <div className="mt-3">{details}</div>}
      {below && <div className="mt-4">{below}</div>}
    </header>
  );
}

export function PaperEmptyState({ message, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-start gap-3 px-2 py-10">
      <p className="text-[14px] text-muted-foreground">{message}</p>
      {action}
    </div>
  );
}
